export default __webpack_public_path__ + "e4b3fed.png";